import WftdaTeamSearchController from "./wftda_team_search_controller"

// Generic record picker for the WFTDA super-admin modals (merge league, merge
// team, assign league): searching reuses the WFTDA autocomplete, and selecting
// a result fills the hidden id field and enables the submit. Typing again
// invalidates the pick so a stale id can never be submitted.
export default class extends WftdaTeamSearchController {
  static targets = ["input", "results", "selectedId", "submit"]

  connect() {
    super.connect()
    this.inputTarget.addEventListener("input", this.invalidate)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.invalidate)
    super.disconnect()
  }

  select(event) {
    const { pickId, pickName } = event.currentTarget.dataset
    this.selectedIdTarget.value = pickId
    this.inputTarget.value = pickName
    this.submitTarget.disabled = false
    this.hide()
  }

  invalidate = () => {
    this.selectedIdTarget.value = ""
    this.submitTarget.disabled = true
  }
}
